export default {
  invites: {},
  status: {},
};